import { useQuery } from '@tanstack/react-query'
import { fetchTheses } from '../../lib/api'
import { thesisTitle } from '../theses/thesisShared'
import { fetchThesisTrades, fetchThesisScriptRuns } from '../../lib/tradesApi'

export interface ThesisOption {
  id: string
  name: string
}

export function useTheses() {
  // Shares the ['theses'] cache (raw array) with the list page; `select`
  // maps to the option shape per-consumer so the cached value stays one type.
  return useQuery({
    queryKey: ['theses'],
    queryFn: fetchTheses,
    select: (theses) => ({ theses: theses.map((t): ThesisOption => ({ id: t.id, name: thesisTitle(t) })) }),
  })
}

export function useThesisTrades(thesisId: string | undefined) {
  return useQuery({
    queryKey: ['thesis-trades', thesisId],
    queryFn: () => fetchThesisTrades(thesisId!),
    enabled: !!thesisId,
    refetchInterval: 5_000,
  })
}

export function useThesisScriptRuns(thesisId: string, limit = 50) {
  return useQuery({
    queryKey: ['thesis-script-runs', thesisId, limit],
    queryFn: () => fetchThesisScriptRuns(thesisId, limit),
    enabled: !!thesisId,
    refetchInterval: 30_000,
  })
}
